export class Ease {
  public static easeOutSine(x: number) {
    return Math.sin((x * Math.PI) / 2);
  }

  public static easeOutQuart(x: number) {
    return 1 - Math.pow(1 - x, 4);
  }

  public static easeOutCirc(x: number): number {
    return Math.sqrt(1 - Math.pow(x - 1, 2));
  }

  public static easeOutExpo(x: number): number {
    return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
  }
}
